<template>
	<div class="v-form">
		<label class="v-form-label">
			<v-text>{{label}}</v-text>
			<slot name="label"/>
		</label>
		<div class="v-form-content">
			<slot/>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    label: {
      default: ""
    },
    labelWidth: {
      default: ""
    },
    inline: {
      default: false
    }
  }
};
</script>

<style lang="less">
.v-form {
  padding: 10px;
  > .v-form-label {
    display: block;
    color: #333333;
    line-height: 32px;
  }
  > .v-form-content {
    margin: 10px 0px;
    position: relative;
    > .v-item {
      > .v-item-label {
        width: 100px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/vue-ext/components/form/index.vue